import { Injectable, Inject } from '@angular/core';
import { Actions } from '@ngrx/effects';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Action } from '@ngrx/store';

@Injectable()
export class AuthenticationEffects {
  // Register$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(Register),
  //     exhaustMap(({ email, first_name, password }) =>
  //       this.authService.register(email, first_name, password).pipe(
  //         map((user) => {
  //           this.router.navigate(['/auth/login']);
  //           return loginSuccess();
  //         }),
  //         catchError((error) => of(loginFailure({ error })))
  //       )
  //     )
  //   )
  // );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}
}
